module.exports = __webpack_public_path__ + "static/media/cooperate.e59678f1.svg";